import { render, staticRenderFns } from "./ScrollSticky.vue?vue&type=template&id=30a0117a&scoped=true"
import script from "./ScrollSticky.vue?vue&type=script&lang=js"
export * from "./ScrollSticky.vue?vue&type=script&lang=js"
import style0 from "./ScrollSticky.vue?vue&type=style&index=0&id=30a0117a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0117a",
  null
  
)

export default component.exports